import React, { ReactNode } from "react";
import styled from "styled-components";

import { moveDownAndFadeIn, moveUpAndFadeOut } from "@/styles/Mixins";
import Svg from "@/styles/Svg";

export const animationHeight = "100px";

export type OverlayProps = {
  icons: IIcons;
  dismiss?: boolean;
  onClose?: () => void;
  showCloseButton?: boolean;
  children?: ReactNode;
};

export class Overlay extends React.Component<OverlayProps> {
  public componentDidUpdate(prevProps: OverlayProps): void {
    const { dismiss, showCloseButton, onClose } = this.props;
    if (!showCloseButton && !prevProps.dismiss && dismiss) {
      setTimeout(() => onClose && onClose(), 150);
    }
  }

  public render(): JSX.Element {
    const { icons, showCloseButton, dismiss, children, onClose } = this.props;
    return (
      <Flexbox className={!showCloseButton && dismiss ? "fadeOut" : "fadeIn"}>
        <Content>
          {children}
          {showCloseButton && (
            <CloseButton onClick={onClose} data-qa="overlay:btn:close">
              <Svg contents={icons.CloseLite} height={10} width={10} />
            </CloseButton>
          )}
        </Content>
      </Flexbox>
    );
  }
}

const CloseButton = styled.div<any>`
  color: ${(props: any) => props.theme.colors.fontTextLight};
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  padding-top: 5px;
  cursor: pointer;
`;

const Flexbox = styled.div<any>`
  display: flex;
  position: absolute;
  z-index: ${(props: any) => props.theme.zIndex.h200};
  padding: 0;
  width: 100%;
  bottom: 0;
  top: 0;
  ${(props: any) =>
    props.theme.borders.interaction && `border: 4px solid transparent;`}

  &.fadeIn {
    animation: ${moveDownAndFadeIn({ size: animationHeight })} 250ms linear;
  }

  &.fadeOut {
    opacity: 0;
    transform: translateY(-${animationHeight}});
    animation: ${moveUpAndFadeOut({ size: animationHeight })} 150ms linear;
  }
`;

const Content = styled.div<any>`
  display: flex;
  position: relative;
  padding: 20px 10px 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: ${(props: any) => props.theme.colors.notification};
  ${(props: any) =>
    props.theme.borders.interaction &&
    `border-radius: ${props.theme.borders.interaction};`}
  justify-content: center;
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    justify-content: left;
  }
  align-items: center;
  color: ${(props: any) => props.theme.colors.fontTextLight};
`;
